import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
} from "@mui/material";
import {useConfigs} from "context/ConfigsContext";
import {useAuthenticatedUser} from "hooks/useAuth";
import type {FC} from "react";
import {useNavigate} from "react-router";
import {getDefaultLandingPath} from "router/utils";

const ErrorPage404: FC = () => {
  const navigate = useNavigate();
  const user = useAuthenticatedUser();
  const defaultLandingPath = "/" + getDefaultLandingPath(user);
  const {configs} = useConfigs();

  const support = configs?.support;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      px={2}>
      <Card sx={{maxWidth: 500, textAlign: "center", p: 3}}>
        <CardContent>
          <Typography variant="h1" color="textDisabled" fontWeight="bold">
            404
          </Typography>
          <Typography
            variant="h5"
            color="textPrimary"
            sx={{mt: 1, fontWeight: "bold"}}>
            The page you're looking for could not be found.
          </Typography>
          <Divider sx={{my: 3}} />
          <Typography variant="body1" color="textSecondary">
            The page you're looking for might have been moved, deleted, or
            renamed.
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{mt: 1}}>
            If you think this is a mistake,{" "}
            {support?.email ? (
              <a href={`mailto:${support.email}`}>report a broken link</a>
            ) : (
              "report a broken link"
            )}
            .
          </Typography>
          <Box display="flex" justifyContent="space-evenly" gap={2}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => navigate(-1)}
              sx={{mt: 3}}>
              Go Back
            </Button>

            {user && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate(defaultLandingPath ?? "/")}
                sx={{mt: 3}}>
                Go Home
              </Button>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ErrorPage404;
